module.exports = __webpack_public_path__ + "img/2023-21.547e463a.jpg";